import React, {useState, useEffect} from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Grid
} from '@material-ui/core';
import {Delete, Edit} from '@material-ui/icons';
import api from "../../api";
import {toast, ToastContainer} from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import "../../css/global.css";


function FactoryList() {
    const [factories, setFactories] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteFactoryId, setDeleteFactoryId] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [editFactoryId, setEditFactoryId] = useState(null);
    const [editFactoryName, setEditFactoryName] = useState('');
    const [editFactoryAddress, setEditFactoryAddress] = useState('');
    const [editFactoryMobile, setEditFactoryMobile] = useState('');
    const [editFactoryRate, setEditFactoryRate] = useState('');
    const [editFactoryCode, setEditFactoryCode] = useState('');
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [newFactoryName, setNewFactoryName] = useState('');
    const [newFactoryAddress, setNewFactoryAddress] = useState('');
    const [newFactoryMobile, setNewFactoryMobile] = useState('');
    const [newFactoryRate, setNewFactoryRate] = useState('');
    const [newFactoryCode, setNewFactoryCode] = useState('');
    const [newFactoryUserName, setNewFactoryUserName] = useState('');
    const [newFactoryUserUserName, setNewFactoryUserUserName] = useState('');
    const [newFactoryUserMobileNumber, setNewFactoryUserMobileNumber] = useState('');
    const [newFactoryUserPassword, setNewFactoryUserPassword] = useState('');
    const [createFactoryError, setCreateFactoryError] = useState('');

    const handleEditOpen = (factoryId, factoryName, factoryAddress, factoryMobile, factoryRate, factoryCode) => {
        setOpenEditDialog(true);
        setEditFactoryId(factoryId);
        setEditFactoryName(factoryName);
        setEditFactoryAddress(factoryAddress);
        setEditFactoryMobile(factoryMobile);
        setEditFactoryRate(factoryRate);
        setEditFactoryCode(factoryCode);
    };

    const handleEditClose = () => {
        setOpenEditDialog(false);
        setEditFactoryId(null);
        setEditFactoryName('');
        setEditFactoryAddress('');
        setEditFactoryMobile('');
        setEditFactoryRate('');
        setEditFactoryCode('');
        window.location.reload();
    };

    const handleDeleteOpen = (factoryId) => {
        setOpenDeleteDialog(true);
        setDeleteFactoryId(factoryId);
    };

    const handleDeleteClose = () => {
        setOpenDeleteDialog(false);
        setDeleteFactoryId(null);
        window.location.reload();
    };

    const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))

    const handleEditSubmit = async () => {
        try {
            const response = await api.post(`/factory/${editFactoryId}`, {
                name: editFactoryName,
                address: editFactoryAddress,
                mobile_number: p2e(editFactoryMobile),
                rate: editFactoryRate,
                tracking_code_base: editFactoryCode,
            });
            handleEditClose();
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const handleDeleteSubmit = async () => {
        try {
            await api.delete(`/factory/${deleteFactoryId}`);
            handleDeleteClose();
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const handleCreateOpen = () => {
        setOpenCreateDialog(true);
    };

    const handleCreateClose = () => {
        setOpenCreateDialog(false);
        setNewFactoryName('');
        setNewFactoryAddress('');
        setNewFactoryMobile('');
        setNewFactoryRate('');
        setNewFactoryCode('');
        setNewFactoryUserName('');
        setNewFactoryUserUserName('');
        setNewFactoryUserMobileNumber('');
        setNewFactoryUserPassword('');
        setCreateFactoryError('');
        window.location.reload();
    };

    const createFactory = async (name, address, mobile_number, rate, code, user_name, user_username, user_mobile, password) => {
        try {
            const createData = {
                'name': name,
                'address': address,
                'mobile_number': p2e(mobile_number),
                'rate': rate,
                'tracking_code_base': code,
                'user': {
                    'name': user_name,
                    'username': p2e(user_username),
                    'mobile_number': p2e(user_mobile),
                    'password': password
                }
            }
            const response = await api.post('/factory', createData)
                .then((res) => {
                    toast.success(res.data.message)
                    handleCreateClose()
                })
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const handleCreateSubmit = async () => {
        if (
            !newFactoryName ||
            !newFactoryAddress ||
            !newFactoryMobile ||
            !newFactoryUserName ||
            !newFactoryUserUserName ||
            !newFactoryUserMobileNumber ||
            !newFactoryUserPassword
        ) {
            toast.error('لطفا همه ی فیلد های الزامی را پر کنید');
            return;
        }

        try {
            const response = await createFactory(
                newFactoryName,
                newFactoryAddress,
                newFactoryMobile,
                newFactoryRate,
                newFactoryCode,
                newFactoryUserName,
                newFactoryUserUserName,
                newFactoryUserMobileNumber,
                newFactoryUserPassword)
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get("/factory");
                setFactories(response.data.data);
            } catch (error) {
                toast.error(error.response.data.message)
            }
        }

        fetchData();
    }, []);

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="card border-3 rounded-4 border-dark mb-4">
                            <div className="card-header bg-dark text-center">
                                <button
                                    className='btn btn-lg btn-dark fw-bold fs-5'
                                    onClick={handleCreateOpen}
                                >
                                    <AddIcon/> ایجاد شعبه جدید
                                </button>
                            </div>
                            <div className="card-body">
                                <div className='table-responsive'>
                                    <table className="table table-hover table-striped table-bordered table-rounded">
                                        <thead>
                                        <tr className="text-center shadow pb-4"
                                            style={{backgroundColor: 'var(--header-color)'}}>
                                            <th>نام شعبه</th>
                                            <th>آدرس</th>
                                            <th>شماره موبایل</th>
                                            <th>رتبه</th>
                                            <th>سر شماره کد پیگیری</th>
                                            <th>ویرایش</th>
                                            <th>حذف</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {factories.map(factory => (
                                            <tr key={factory.id} className="rounded-row" style={{borderRadius: '10px'}}>
                                                <td className="text-center">
                                                    {factory.name}
                                                </td>
                                                <td>{factory.address}</td>
                                                <td className="text-center">{factory.mobile_number}</td>
                                                <td className="text-center">{factory.rate}</td>
                                                <td className="text-center">{factory.tracking_code_base}</td>
                                                <td className="text-center">
                                                    <IconButton onClick={() => handleEditOpen(
                                                        factory.id,
                                                        factory.name,
                                                        factory.address,
                                                        factory.mobile_number,
                                                        factory.rate,
                                                        factory.tracking_code_base
                                                    )}>
                                                        <Edit color="primary"/>
                                                    </IconButton>
                                                </td>
                                                <td className="text-center">
                                                    <IconButton onClick={() => handleDeleteOpen(factory.id)}>
                                                        <Delete color="secondary"/>
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <Dialog className="text-center" open={openDeleteDialog} onClose={handleDeleteClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">
                                    حذف شعبه
                                </p>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    آیا مطمئن هستید که میخواهید شعبه را حذف کنید ؟
                                </DialogContentText>
                            </DialogContent>
                            <input className='btn btn-danger mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleDeleteSubmit}
                                   value="حذف"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleDeleteClose}
                                   value="انصراف"
                            />
                        </Dialog>
                        <Dialog open={openEditDialog} onClose={handleEditClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">ویرایش اطلاعات</p>
                            </DialogTitle>
                            <DialogContent>
                                <form>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <label className='form-label'>نام شعبه</label>
                                            <input
                                                required
                                                type='text'
                                                variant="outlined"
                                                className='form-control shadow'
                                                value={editFactoryName}
                                                onChange={e => setEditFactoryName(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>آدرس</label>
                                            <textarea
                                                required
                                                variant="outlined"
                                                className='form-control shadow'
                                                value={editFactoryAddress}
                                                onChange={e => setEditFactoryAddress(e.target.value)}
                                            ></textarea>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>شماره موبایل</label>
                                            <input
                                                required
                                                type='text'
                                                maxLength={11}
                                                className='form-control shadow'
                                                variant="outlined"
                                                value={editFactoryMobile}
                                                onChange={e => setEditFactoryMobile(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>رتبه</label>
                                            <input
                                                className='form-control shadow'
                                                type='number'
                                                variant="outlined"
                                                value={editFactoryRate}
                                                onChange={e => setEditFactoryRate(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>سر شماره کد رهگیری</label>
                                            <input
                                                className='form-control shadow'
                                                type='number'
                                                variant="outlined"
                                                value={editFactoryCode}
                                                onChange={e => setEditFactoryCode(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                            <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleEditSubmit}
                                   value="ذخیره"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleEditClose}
                                   value="انصراف"
                            />
                        </Dialog>
                        <Dialog open={openCreateDialog} onClose={handleCreateClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">ایجاد شعبه جدید</p>
                            </DialogTitle>
                            <DialogContent>
                                <form onSubmit={handleCreateSubmit}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <label className='form-label'>نام شعبه</label>
                                            <input
                                                error={!!createFactoryError}
                                                helperText={createFactoryError}
                                                required
                                                type='text'
                                                className='form-control shadow'
                                                variant="outlined"
                                                value={newFactoryName}
                                                onChange={e => setNewFactoryName(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>آدرس</label>
                                            <textarea
                                                required
                                                className='form-control shadow'
                                                variant="outlined"
                                                value={newFactoryAddress}
                                                onChange={e => setNewFactoryAddress(e.target.value)}
                                            ></textarea>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>شماره موبایل</label>
                                            <input
                                                required
                                                type='text'
                                                className='form-control shadow'
                                                maxLength={11}
                                                variant="outlined"
                                                value={newFactoryMobile}
                                                onChange={e => setNewFactoryMobile(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>رتبه</label>
                                            <input
                                                type='number'
                                                label="رتبه"
                                                className='form-control shadow'
                                                variant="outlined"
                                                value={newFactoryRate}
                                                onChange={e => setNewFactoryRate(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>سر شماره کد رهگیری</label>
                                            <input
                                                type='number'
                                                label="کد"
                                                className='form-control shadow'
                                                variant="outlined"
                                                value={newFactoryCode}
                                                onChange={e => setNewFactoryCode(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>نام و نام خانوادگی مسئول</label>
                                            <input
                                                required
                                                className='form-control shadow'
                                                type='text'
                                                variant="outlined"
                                                value={newFactoryUserName}
                                                onChange={e => setNewFactoryUserName(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>شماره ملی مسئول</label>
                                            <input
                                                required
                                                className='form-control shadow'
                                                type='text'
                                                maxLength={10}
                                                variant="outlined"
                                                value={newFactoryUserUserName}
                                                onChange={e => setNewFactoryUserUserName(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>شماره موبایل مسئول</label>
                                            <input
                                                required
                                                className='form-control shadow'
                                                type='text'
                                                maxLength={11}
                                                variant="outlined"
                                                value={newFactoryUserMobileNumber}
                                                onChange={e => setNewFactoryUserMobileNumber(e.target.value)}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <label className='form-label'>رمز عبور</label>
                                            <input
                                                required
                                                className='form-control shadow'
                                                type='text'
                                                variant="outlined"
                                                value={newFactoryUserPassword}
                                                onChange={e => setNewFactoryUserPassword(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                            <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleCreateSubmit}
                                   value="ذخیره"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleCreateClose}
                                   value="انصراف"
                            />
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FactoryList;
